export const home = '/';
export const jobs = '/jobs';
export const customers = '/customers';
export const moments = '/moments';
export const jobConfigs = '/products';
export const members = '/members';
export const companyProfile = '/company';
export const contentProviders = '/providers';
export const configureApps = '/configure';
export const userProfile = '/profile';
export const kiosks = '/kiosks';
export const marketing = '/marketing';
export const purchases = '/purchases';
export const reports = '/reports';
export const uploads = '/uploads';
export const salesReport = '/sales_report';
export const analyticsReport = '/analytics_report';
export const photographerHourlyReport = '/photographer_hourly_report';
export const dailyReadReport = '/daily_read_report';
export const catalogs = '/catalogs';
export const qrCodeGenerator = '/qrcode_generator';
export const login = '/login';
export const twoFactor = '/login/mfa';
export const passwordReset = '/login/reset';
export const passwordUpdate = '/login/update/:token';
export const acceptInvite = '/login/accept/:token';
export const guests = '/guests';

export const admin = '/admin/*';
export const accounts = '/admin/accounts';
export const jobConfigTemplates = '/admin/marketplace';
export const billing = '/admin/billing';
export const accountBillings = '/admin/account_billing';
export const accountPricings = '/admin/account_pricing';
export const billingReport = '/admin/billing_report';
export const billingExportSchedules = '/admin/billing_export_schedules';
export const accessCodePages = '/admin/access_code_pages';
export const gdpr = '/admin/gdpr';
export const adminDailyReadReport = '/admin/daily_read_report';
export const workerStatusReport = '/admin/worker_status_report';